module.exports = __webpack_public_path__ + "img/MC6.0272b3ef.webp";